import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchmyplan(value) {
  const token = localStorage.getItem("token");
  let page = (value.value && value.value.page) || 1;
  let user = JSON.parse(localStorage.getItem("user"));
  let search = (value.value && value.value.search) || "";
  let id = user.orgId;
  try {
    const res = yield fetch(
      `${appConfig.ip}/subscriptnPlan?orgId=${id}&isActive=true&limit=10&ser=${search}&page=${page}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_MYPLAN_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: actionTypes.FETCH_MYPLAN_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchcurrency(params) {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/currency`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_CURRENCY_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: actionTypes.FETCH_CURRENCY_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* addPlan(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  console.log("-------------user----", user);

  const data = {
    name: value.value.name,
    crncy: user.curncyCode,
    amount: value.value.amount,
    validity: value.value.validity,
    noOfLoads: value.value.noOfLoads,
    kms: value.value.kms,
    cargoSize: value.value.cargoSize,
    orgId: user.orgId,
    user: user.id,
  };
  console.log("-------------data----", data);
  try {
    const res = yield fetch(`${appConfig.ip}/subscriptnPlan`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.ADD_PLAN_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success("Plan added successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
      yield put({
        type: actionTypes.FETCH_MYPLAN_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_PLAN_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* editPlan(value) {
  let id = value.id;

  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  // let data = value.params;
  const data = {
    name: value.params.name,
    crncy: value.params.crncy,
    amount: value.params.amount,
    validity: value.params.validity,
    noOfLoads: value.params.noOfLoads,
    kms: value.params.kms,
    cargoSize: value.params.cargoSize,
    orgId: user.orgId,
    user: user.id,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/subscriptnPlan/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield put({ type: actionTypes.FETCH_MYPLAN_ACTION });
      yield put({
        type: actionTypes.EDIT_PLAN_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success("Plan updated successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.EDIT_PLAN_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* deletePlan(params) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  let id = params.data.id;

  let data = {
    name: params.data.name,
    crncy: params.data.crncy.id,
    amount: params.data.amount,
    validity: params.data.validity,
    noOfLoads: params.data.noOfLoads,
    kms: params.data.kms,
    cargoSize: params.data.cargoSize,
    deletedAt: new Date(),
    orgId: user.orgId,
    user: user.id,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/subscriptnPlan/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ isActive: false, ...data }),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: actionTypes.FETCH_MYPLAN_ACTION });
      yield put({
        type: actionTypes.DELETE_PLAN_SUCCESS_ACTION,
        payload: id,
      });
      yield toast.success("Plan deleted successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.DELETE_PLAN_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchPlanCargoSize() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/cargoSize?isActive=true`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_PLAN_CARGOSIZE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_PLAN_CARGOSIZE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchPlanCargosizeList() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/loadMetrics?isActive=true`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_PLAN_CARGOSIZELIST_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_PLAN_CARGOSIZELIST_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* MyPlanActionWatcher() {
  yield takeEvery(actionTypes.FETCH_MYPLAN_ACTION, fetchmyplan);
  yield takeEvery(actionTypes.FETCH_CURRENCY_INIT_ACTION, fetchcurrency);
  yield takeEvery(actionTypes.ADD_PLAN_INIT_ACTION, addPlan);
  yield takeEvery(actionTypes.EDIT_PLAN_INIT_ACTION, editPlan);
  yield takeEvery(actionTypes.DELETE_PLAN_INIT_ACTION, deletePlan);
  yield takeEvery(actionTypes.FETCH_PLAN_CARGOSIZE_ACTION, fetchPlanCargoSize);
  yield takeEvery(
    actionTypes.FETCH_PLAN_CARGOSIZELIST_ACTION,
    fetchPlanCargosizeList
  );
}
